<div class="wrap">
  <img class="logo" src="assets/bciti-logo.svg" alt="Logo Bciti">

  <mat-spinner *ngIf="autoLoginInProgress" diameter="40"></mat-spinner>

  <ng-container *ngIf="!autoLoginInProgress">
    <app-form-select
      [options]="orgOptions"
      [placeholder]="'pages.login.selectOrg' | translate"
      [label]="'pages.login.selectOrg' | translate"
      [searchable]="false"
      [disabled]="orgsLoading"
      [displayMessages]="false"
      [noFormControlBorder]="true"
      [(ngModel)]="selectedOption"
      (ngModelChange)="onOrgChange($event)">
    </app-form-select>

    <footer class="action-footer">
      <button
        class="bciti-button bciti-button--blue"
        [class.is-disabled]="!selectedOrg || orgsLoading"
        [disabled]="!selectedOrg || orgsLoading"
        (click)="login()">
        {{ 'pages.login.loginButton' | translate }}
      </button>
    </footer>
  </ng-container>
</div>
